module.exports = __webpack_public_path__ + "media/images/background/apples-db82a4f36133ad26f75b5222420e81c9.jpg";